import { apiClient } from '@/lib/api/client'

export type GeographicOption = {
  id: number
  code?: string
  label: string
  name?: string
  area_cluster_id?: number | null
  region_id?: number | null
  province_id?: number | null
}

function normalizeOptions(payload: unknown): GeographicOption[] {
  if (Array.isArray(payload)) return payload as GeographicOption[]
  if (payload && typeof payload === 'object' && Array.isArray((payload as { data?: unknown }).data)) {
    return (payload as { data: GeographicOption[] }).data
  }
  return []
}

export const geographicService = {
  async getAreaClusterOptions(): Promise<GeographicOption[]> {
    const { data } = await apiClient.get('/options/area-clusters')
    return normalizeOptions(data)
  },

  async getRegionOptions(): Promise<GeographicOption[]> {
    const { data } = await apiClient.get('/options/regions')
    return normalizeOptions(data)
  },

  async getProvinceOptions(params?: { areaClusterId?: number; regionId?: number }): Promise<GeographicOption[]> {
    const { data } = await apiClient.get('/options/provinces', {
      params: {
        area_cluster_id: params?.areaClusterId,
        region_id: params?.regionId,
      },
    })
    return normalizeOptions(data)
  },

  async getTownOptions(provinceId?: number): Promise<GeographicOption[]> {
    const { data } = await apiClient.get('/options/towns', {
      params: provinceId ? { province_id: provinceId } : undefined,
    })
    return normalizeOptions(data)
  },
}
